export const ARIVA_BASE_URL = "https://www.ariva.de";

export const arivaInstrumentUrl = (isin: string): string =>
  `${ARIVA_BASE_URL}/${isin}`;

export const arivaNewsUrl = (newsUrl: string): string =>
  newsUrl.startsWith("http") ? newsUrl : `${ARIVA_BASE_URL}${newsUrl}`;
